<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-03-04 16:23:29
 * @LastEditTime: 2023-05-16 11:07:09
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: 
 * @FilePath: /zdzyframe_menhu/src/App.vue
-->
<template>
  <div id="app">
    <!-- <heard @goAnchor="goAnchor"></heard> -->
     <!-- <imgbg></imgbg> -->
    <router-view />
    <!-- <footers></footers> -->

  </div>
</template>

<script>

  export default {
    name: 'App',
    data() {
      return {
      }
    },

    components: {

    },
    computed: {
    
  },
    watch:{

  },
  mounted(){


  },
    methods: {

    },
  }
</script>

<style lang="less">

@import url('./assets/css/reset.css');
  html,
  body {
    margin: 0;
    padding: 0;
  
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;
    padding: 0;
  }





</style>


// WEBPACK FOOTER //
// src/App.vue